export default class BrandReviews {
  DEBUG = false;
  API_URL = "https://cl.avis-verifies.com/fr/cache/d/c/c/dcc5ca4e-68df-c414-bd7f-53ef20145ddc/AWS/WEBSITE_API/reviews.json";
  SECTION = undefined;
  AVERAGE = {
    note: 0,
    total: 0
  };
  REVIEWS = [];
  REVIEWS_COUNT = {
    1: {
      count: 0,
      percent: 0
    },
    2: {
      count: 0,
      percent: 0
    },
    3: {
      count: 0,
      percent: 0
    },
    4: {
      count: 0,
      percent: 0
    },
    5: {
      count: 0,
      percent: 0
    }
  };
  REVIEWS_NUMBER = 20;
  constructor(section, reviewsNumber, callback) {
    this.SECTION = section;
    this.REVIEWS_NUMBER = reviewsNumber;
    this.DEBUG ? console.log("SECTION", section) : null;
    this.DEBUG ? console.log("REVIEWS NUMBER", this.REVIEWS_NUMBER) : null;
  }
  init(callback) {
    this.getBrandReviews().then(data => {
      this.REVIEWS = data;
      this.DEBUG ? console.log("REVIEWS", this.REVIEWS) : null;
      this.AVERAGE.total = this.REVIEWS.length;
      let averageNote = this.REVIEWS.reduce((acc, review) => acc + parseInt(review.rate), 0) / this.AVERAGE.total;
      this.AVERAGE.note = Math.round(averageNote * 10) / 10;
      this.DEBUG ? console.log("AVERAGE", this.AVERAGE) : null;
      if (this.REVIEWS.length === 0) {
        this.removeReviews("No reviews found");
        return;
      }
      if (callback) {
        callback();
      }
    }).catch(err => {
      console.error(err);
      this.removeReviews("Error occured during reviews fetching");
    });
  }
  getBrandReviews() {
    console.log('get brand reviews');
    return fetch(this.API_URL).then(response => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error("Error while fetching reviews");
      }
    }).catch(err => {
      throw new Error(err);
    });
  }
  removeReviews(err) {
    console.log('remove reviews');
    this.DEBUG ? console.error(err) : "";
    this.AVERAGE = undefined;
    this.REVIEWS = undefined;
    if (document.querySelector('#brand-reviews')) {
      document.querySelector('#brand-reviews').remove();
    }
  }
  generateHtml() {
    if (this.REVIEWS !== undefined) {
      this.injectDataInHeader();
      this.injectReviews();
    }
  }
  injectDataInHeader() {
    console.log('inject data in header');
    document.querySelector('#brand-reviews .br-header__average-text .rate').innerText = this.AVERAGE?.note;
    document.querySelector('#brand-reviews .br-header__average-count .count').innerText = this.AVERAGE?.total;

    //On multiplie la note par 20 pour passer d'une note sur 5 à une note sur 100.
    document.querySelector(`#brand-reviews .br-header__average-stars-icon-active`).style.width = this.AVERAGE?.note * 20 + "%";
  }
  injectReviews() {
    console.log('inject reviews');
    const review_template = window.customerReviewsTemplate.brand_review;
    let reviews_html = "";
    let reviewsToDisplay = this.REVIEWS.slice(0, this.REVIEWS_NUMBER);
    reviewsToDisplay.forEach((review, index) => {
      //On créer un élément HTML que l'on va pouvoir manipuler pour créer le html de notre review
      let html = document.createElement("template");
      html.innerHTML = review_template;

      //On injecte toutes les variables dans notre template.
      let ordered_at = new Date(review.order_date);
      html.content.querySelector('.br-review__author-name').innerHTML = review.firstname !== "anonymous" ? review.firstname : window.i18n.productReviews.anonymous;
      html.content.querySelector('.br-review__date span').innerHTML = ('0' + ordered_at.getDate()).slice(-2) + "/" + ('0' + (ordered_at.getMonth() + 1)).slice(-2) + "/" + ordered_at.getFullYear();
      html.content.querySelector('.br-review__text p').innerHTML = review.review;
      let stars = html.content.querySelectorAll('.br-review__rate > .br-review__rate-star');
      for (let i = 0; i < review.rate; i++) {
        stars[i].classList.add('active');
      }
      reviews_html += html.innerHTML;
    });
    document.querySelector(".br-carousel").innerHTML = reviews_html;
    setTimeout(() => {
      let carousel = document.querySelector('#brand-reviews flickity-carousel');
      carousel.reload();
      this.initCarousel(carousel);
    }, 200);
  }
  removeSection(err) {
    console.log('remove reviews section');
    this.DEBUG ? console.error(err) : "";
    if (document.querySelector('#brand-reviews')) {
      document.querySelector('#brand-reviews').remove();
    }
  }
  initCarousel(carousel) {
    document.querySelector('.flickity-next-custom').addEventListener('click', () => {
      carousel.next();
    });
    document.querySelector('.flickity-previous-custom').addEventListener('click', () => {
      carousel.previous();
    });
  }
}